import { Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

@Component({
  selector: 'kt-info-view-bs',
  templateUrl: './info-view-bs.component.html',
  styleUrls: ['./info-view-bs.component.scss'],
})
export class InfoViewBsComponent {
  today = new Date();
  constructor(
    @Inject(MatBottomSheetRef)
    public bsRef: MatBottomSheetRef<InfoViewBsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

  close() {
    this.bsRef.dismiss();
  }
}
